<template>
  <div class="credit-list-main-page">
    <main-header :hasBanner="true" :type="'jgGood'"></main-header>
    <section class="main-center list-clr">
      <list-left :type="'jgGood'"></list-left>
      <div class="page-right">
        <div class="right-top">
          <div class="right-title">经纪机构良好行为记录排名</div>
        </div>
        <el-table stripe :data="tableData" border style="width: 100%">
          <el-table-column
            align="centet"
            header-align="center"
            prop=""
            label="排行"
            width="120"
          >
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="companyName"
            label="经纪机构名称"
          ></el-table-column>
     
          <el-table-column
            align="centet"
            header-align="center"
            label="详细"
            width="80"
          >
            <template slot-scope="scope">
              <img
                @click="goDetail(scope.row)"
                style="width: 20px; cursor: pointer"
                src="@/assets/img/search.png"
                alt=""
              />
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="bottom-pagination"
          background
          @current-change="handleCurrentChange"
          :current-page="pagingObj.pageNum"
          :page-size="pagingObj.pageSize"
          layout="prev, pager, next, jumper, total "
          :total="total"
        >
        </el-pagination>
      </div>
    </section>
    <main-footer></main-footer>
  </div>
</template>

<script>
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
import listLeft from "@/components/listLeft";
import {  behavior } from "@/assets/api/company";


export default {
  name: "creditList",
  components: {
    mainHeader,
    mainFooter,
    listLeft,
  },

  data() {
    return {
      selval: "",
      tableData: [
    
      ],
      pagingObj: {
        good: 1,
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
    };
  },
  computed: {},
  mounted() {
    this.getData();
  },
  methods: {
    goDetail(item) {
      const jumpUrl = this.$router.resolve({ path: "/company/detail",query: { id: item.companyId }, });
      window.open(jumpUrl.href, "_blank");
    },
    handleCurrentChange(val) {
      this.pagingObj.pageNum = val;
      this.getData();
    },
    async getData() {
      const res = await behavior(this.pagingObj);
      if (res && res.data && res.data.code == 200) {
          this.tableData = res.data.rows || [];
          this.total = res.data.total;
      }
    }
  },
};
</script>

<style lang="less">
.credit-list-main-page {
  background: #fff;
  .list-clr {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;

    .page-right {
      flex: 1;
      .right-top {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .right-title {
          font-size: 18px;
          color: #222;
        }
        .ad-select {
          width: 203px;
          input {
            height: 50px;
            border-radius: 0;
          }
        }
        .ad-input {
          width: 720px;
          height: 50px;
          border: 1px solid #dcdfe6;
          border-right: 0;
          padding: 6px 12px;
        }
        .search-btn {
          background: #9b2f3d;
          width: 140px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          color: #fff;
          font-weight: bold;
          font-size: 16px;
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          cursor: pointer;
        }
      }
    }
  }
  .mg-t20 {
    margin-top: 20px;
  }

  .el-table .cell {
    overflow: initial !important;
  }
  .el-table {
    overflow: initial !important;
  }
  .el-table__body-wrapper {
    overflow: initial !important;
  }
  .qr-box {
    position: relative;
    z-index: 2;
    img {
      position: absolute;
      z-index: 1;
      left: -50px;
      top: 10px;
    }
  }
  .bottom-pagination {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-left: 0;
    padding-right: 0;
  }
}
</style>